import { Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import EventIcon from '@mui/icons-material/Event';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { FormattedMessage } from 'react-intl';
import { useCurrency } from '@features/currency/currency.hooks';

type RevenuCardProps = {
  selectedDay: RevenueStatistic;
  onClose: () => void;
};

export type RevenueStatistic = {
  profit: number;
  costs: number;
  revenue: number;
  label: string;
};

const RevenuCard = (props: RevenuCardProps) => {
  const { selectedDay, onClose } = props;
  const { preferredCurrency } = useCurrency();

  return (
    <Card
      sx={{
        minWidth: 320,
        borderRadius: 3,
        boxShadow: 2,
        bgcolor: '#f6f4ef',
        px: 2,
        py: 1,
      }}
      onClick={onClose}
    >
      <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
        <Stack spacing={1.2}>
          <Stack direction="row" spacing={3} justifyContent="space-between">
            <Stack direction="row" spacing={1} alignItems="center">
              <EventIcon color="info" fontSize="small" />
              <Typography variant="subtitle2" fontWeight="bold">
                {selectedDay.label}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <TrendingUpIcon fontSize="small" color="success" />
              <Typography variant="body2" fontWeight="bold">
                <FormattedMessage
                  id="procedureCard.profit"
                  defaultMessage={`Zisk: ${Math.round(selectedDay.profit)} ${preferredCurrency}`}
                />
              </Typography>
            </Stack>
          </Stack>
          <Divider />
          <Stack direction="row" spacing={3} justifyContent="space-between">
            <Stack direction="row" spacing={1} alignItems="center">
              <RemoveCircleOutlineIcon fontSize="small" color="error" />
              <Typography variant="body2">
                <FormattedMessage
                  id="procedureCard.costs"
                  defaultMessage={`Náklady: ${Math.round(selectedDay.costs)} ${preferredCurrency}`}
                />
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <ControlPointIcon fontSize="small" color="success" />
              <Typography variant="body2">
                <FormattedMessage
                  id="procedureCard.revenue"
                  defaultMessage={`Tržba: ${Math.round(selectedDay.revenue)} ${preferredCurrency}`}
                />
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default RevenuCard;
